module.exports = __webpack_public_path__ + "img/faf0095.png";